import general from 'services/locales/en/general';
import { LinkInfo } from './types';

export const aboutUs: Record<string, LinkInfo> = {
  aboutUs: {
    url: 'https://www.loudly.com/about',
    label: general.footer.aboutUs.about,
  },
  blog: {
    url: 'https://www.loudly.com/blog',
    label: general.footer.aboutUs.blog,
  },
  faqs: {
    url: 'https://www.loudly.com/faq',
    label: general.footer.aboutUs.FAQs,
  },
  contactUs: {
    url: 'mailto: help@loudly.com',
    label: general.footer.aboutUs.contactUs,
  },
};
